import { render, staticRenderFns } from "./kcon.vue?vue&type=template&id=22eff208&scoped=true"
import script from "./kcon.vue?vue&type=script&lang=js"
export * from "./kcon.vue?vue&type=script&lang=js"
import style0 from "./kcon.vue?vue&type=style&index=0&id=22eff208&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eff208",
  null
  
)

export default component.exports